<template>
  <path
    d="M3.00002 11.7711L18.7551 5.10555L10.9822 20.7385L10.0643 13.616L3.00002 11.7711Z"
    stroke="#4F4F4F"
    stroke-width="0.4"
  />
</template>
